export default __webpack_public_path__ + "static/media/VENTO.8b5c0280.jpg";